import { AppPreviewActions } from '.'
import { MediaData } from 'components/MediaViewer'

export interface UpdateIgStoryRepostStep1DataPayload {
    taskTitle?: string
    stepTitle?: string
    submissionRequirementDescription?: string
    mediaDos?: string
    mediaDonts?: string
    captionHashtags?: (
        | {
              value: string
          }
        | undefined
    )[]
    profileTags?: (
        | {
              value: string
          }
        | undefined
    )[]
    exampleMediaDescription?: string
    exampleMedia?: MediaData[]
}

export const updateigStoryRepostStep1Data = (payload: UpdateIgStoryRepostStep1DataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_IG_STORY_REPOST_STEP1_DATA,
})
